module.exports = __webpack_public_path__ + "img/icon512.72491131.png";